<template>
    <div v-if="shoppingCartIsOpen">
        <loading-overlay :active.sync="submissionInProgress" loader="dots" color="#1A74DB" height="30" width="100%" opacity="0.85"></loading-overlay>
        <HardwareOnlyModal ref="hardwareOnlyModal" />
        <div class="cover row" @click="setShoppingCartToClosed"></div>
        <div class="col xs-12 md-4 relative" id="shopping-cart">
            <div class="flex flex-between" id="header">
                <div id="title">{{ webstoreContent.shoppingBag }}</div>
                <div class="close" id="close-shopping-cart" @click="setShoppingCartToClosed"></div>
            </div>
            <template>

                <!-- Contract info -->
                <div class="col notification" v-if="showContractDisclaimer && !hasContractExpired">
                    <div class="cart-notification bold">
                        {{ contractDisclaimer }}
                    </div>
                </div>

                <!-- Products in Cart -->
                <OffersInCart v-if="!isShoppingCartEmpty" />
                <div class="col xs-6 notification" v-else>
                    <div class="cart-notification">0 items in cart.</div>
                </div>
                
                <div class="sticky-wrapper" v-if="!isShoppingCartEmpty">
                    <!-- Subtotal -->
                    <div class="col xs-12" id="subtotal">{{ webstoreContent.subtotal }}: {{ currencySymbol.toUpperCase() }}{{ subtotal.toLocaleString('en-US') }}</div>
                    <!-- Checkout Button -->
                    <v-button
                        position="right"
                        mobile="12"
                        tablet="12"
                        desktop="4"
                        styling="primary"
                        textAlign="center"
                        :disabled="isShoppingCartEmpty"
                        @onClickEvent="submitHandler"
                    >
                        <template v-slot:content>
                            <span>
                                {{ webstoreContent.proceedToCheckout }}
                            </span>
                        </template>
                    </v-button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex';
    import OffersInCart from './offers-in-cart';
    import vButton from '../../utils/button';
    import HardwareOnlyModal from '../webstore/hardware-only-modal';
    import { WebstoreResources } from '../../../mixins/webstore-resources';
    import SalesforceResources from "../../../mixins/salesforce-resources";
    import SegmentResources from "../../../mixins/segment-resources";

    export default {

        mixins: [
            WebstoreResources,
            SalesforceResources,
            SegmentResources,
        ],

        components: {OffersInCart, vButton, HardwareOnlyModal},

        data() {
            return {
                submissionInProgress: false,
            }
        },
        computed: {
            ...mapGetters([
                'shoppingCartIsOpen',
                'currencySymbol',
            ]),

            ...mapGetters('content', [
                'webstoreContent',
                'contractDisclaimer',
            ]),

            ...mapGetters('checkout', [
                'checkoutType',
                'showContractDisclaimer',
                'hideLicenses',
            ]),

            ...mapGetters('shoppingCart', [
                'productsInCart',
                'couldProductInCartHaveLicenses',
            ]),

            subtotal: function() {
                return this.productsInCart.reduce((prev,next) => prev + this.calculateTotalPrice(next.salesPrice) * next.quantity, 0).toFixed(2);
            },

            isShoppingCartEmpty: function() {
                return this.productsInCart.length === 0;
            },
        },
        methods:{
            ...mapMutations([
                'setShoppingCartToClosed',
            ]),

            submitHandler() {
                if (this.couldProductInCartHaveLicenses) {
                    this.$refs.hardwareOnlyModal.isModalVisible = true;
                } else {
                    this.$router.push({path: '/review-cart'});
                }
            },
        },
    }
</script>

<style scoped>

    .notification {
        padding-left: 10px;
        padding-right: 0px;
        margin-top: 14px;
    }

    .cart-notification {
        color: #474F54;
        font-size: 20px;
        line-height: 24px;
    }

    .flex {
        display: flex;
    }

    .flex-center {
        align-items: center;
        justify-content: center;
    }

    .flex-end {
        align-items: center;
        justify-content: flex-end;
    }

    .flex-between {
        align-items: center;
        justify-content: space-between;
    }

    .sticky-wrapper {
        position: sticky;
        bottom: 0;
        background: white;
        padding: 20px 0;
        border-top: 1px solid #E4E7EB;
    }

    #shopping-cart {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0px;
        right: 0px;
        z-index: 100;
        font-family:  "Nitti Grotesk", sans-serif;
        font-style: normal;
        font-weight: normal;
        background-color: white;
        overflow-y: scroll;
        /* for chrome and safari*/
        -webkit-animation-duration: 0.25s;
        -webkit-animation-name: slidein;
        /*for firefox*/
        -moz-animation-duration: 0.25s;
        -moz-animation-name: slidein;
        /* for opera*/
        -o-animation-duration: 0.25s;
        -o-animation-name: slidein;
        /* Standard syntax*/
        animation-duration: 0.25s;
        animation-name: slidein;
    }

    @-webkit-keyframes slidein {
        from {
            transform: translateX(100%);
        }
        to {
            transform: translateX(0);
        }
    }

    @-moz-keyframes slidein {
        from {
            transform: translateX(100%);
        }
        to {
            transform: translateX(0);
        }
    }

    @-o-keyframes slidein {
        from {
            transform: translateX(100%);
        }
        to {
            transform: translateX(0);
        }
    }

    @keyframes slidein {
        from {
            transform: translateX(100%);
        }
        to {
            transform: translateX(0);
        }
    }

    .cover {
        width:100%;
        height:100%;
        position: fixed;
        top:0;
        left:0;
        z-index: 99;
        background:rgba(0,0,0,0.6);
    }

    .close {
        width: 50px;
        height: 50px;
        opacity: 0.9;
        left: 15px;
    }

    .close:hover {
        opacity: 1;
    }

    .close:before, .close:after {
        position: absolute;
        content: ' ';
        height: 30px;
        width: 2px;
        background-color: #101E27;
        right: 50px;
        top: 30px;
    }

    .close:before {
        transform: rotate(45deg);
    }

    .close:after {
        transform: rotate(-45deg);
    }

    #header {
        padding: 20px 12px;
        border-bottom: 1px solid #191D1F;
    }

    #title {
        font-weight: 500;
        font-size: 32px;
        line-height: 32px;
        color: #000000;
    }

    #subtotal {
        font-size: 32px;
        line-height: 32px;
        text-align: right;
        color: #000000;
        margin: 18px 0px;
    }

    #checkout-button-container {
        margin: 18px 0px;
    }

    #checkout-button {
        height: 50px;
        color: white;
        background: #1A74DB;
        border-radius: 4px;
        border: none;
        font-size: 20px;
        font-weight: 500;
        line-height: 20px;
        padding: 0px 24px;
    }

    #checkout-button:hover {
        cursor: pointer;
        background-color: #0d6ede;
        border: #0d6ede;
    }

    #checkout-button:disabled {
        background-color: #657281;
    }

</style>
